<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>ПРОДАЖА БИЗНЕСА – АГРЕГАТОР ХОЧУ-ПОЕСТЬ</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="about__text-block">
        <div class="container">
          <div class="text-block__bottom">
            <div class="text-block__text-wrapper text-block__bottom-bottom">
              <p class="text-block__text">
                <center><p style="font-size: 16pt;"><br/>Мы продаем действующий e-commerce бизнес по доставке еды в нескольких города и странах.</p></center>
              <p>&nbsp;</p>
              <h2><br/><br/><strong>ЭТО ПОЗВОЛИТ ПОКУПАТЕЛЮ:</strong></h2>
              <p><br/> -  Купить готовый действующий на всех платформах бизнес вкладывая только в маркетинг</p>
              <p><br/> -  Купить бизнес без привязки к конкретному месту. IT бизнес позволяет работать где угодно</p>
              <p><br/> -  Начать зарабатывать с первого дня, а не тратить сотни тысяч долларов на разработку, тестирование, внедрение</p>
              <p><br/> -  Получить готовую команду поддержки на 6 месяцев</p>
              <p><br/> -  Развивать собственный франчайзинг</p>
              <p>&nbsp;</p>
              <h2><br/><br/><strong>ЭТО ПОЗВОЛИТ НАМ:</strong></h2>
              <p><br/> -  В сочетании с другими бизнес-моделями произвести гораздо более быстрый захват рынков</p>
              <p><br/> -  Продажа в нашем случае выгоднее чем привлекать дополнительные инвестиции на текущей стадии</p>
              <p><br/> -  Сформировать большой пул предпринимателей – единомышленников из разных городов и стран с которыми мы сможем взаимодействовать и развиваться на равных условиях, но гораздо быстрее</p>
              <p>&nbsp;</p>
              <h2><br/><br/><strong>ПОЧЕМУ ИМЕННО ЭТОТ БИЗНЕС</strong></h2>
              <p><br/> -  Food Tech – самый быстрорастущий рынок в мире</p>
              <p><br/> -  Потенциал рынка один из самых больших и уступает пока только авто и цветочному сегментам, но уже догоняет их</p>
              <p>&nbsp;</p>
              <h2><br/><br/><strong>ГАРАНТИЯ БЕЗОПАСНОЙ СДЕЛКИ</strong></h2>
              <p><br/> 1.  Передаем все права</p>
              <p><br/> 2.  Передаем все IT решения</p>
              <p><br/> 3.  Передаем домены/поддомены и пр</p>
              <p><br/> 4.  Передача всей рабочей документации по организации и управлению</p>
              <p><br/> 5.  Подписываем обязательство о неразглашении информации и запрете на ведение подобной деятельности!</p>
              <p>&nbsp;</p>
              <h2><br/><br/><strong>ГАРАНТИЯ ПОДДЕРЖКИ</strong></h2>
              <p><br/>Собственники обеспечивают поддержку на протяжении минимум 6 месяцев.</p>
              <p><br/>Нам очень важно чтобы бизнес работал и развивался – как и было сказано выше, существует очень большая связь между всеми городами и странами – если мы продали один город, один регион или одну страну, команда под тем же брендом продолжает работу в других регионах и странах!!!</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p style="font-size: 16pt;"><br/>Пишите, обсудим условия - <strong><a href="mailto:sev@hochu-poest.com" style="color: #0000FF">sev@hochu-poest.com</a></strong></p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'sale'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/sale.vue